const isMobileSharePlan = plan => plan && plan.groupName === 'Mobile Share';

export default isMobileSharePlan;
